const DIRECT_DEBIT_MOP_TYPES = new Set(['BR_BA', 'US_BA', 'DIRECT_DEBIT']);

/** Maps LEP MOP types to the encryption payload format expected by Sharkey. */
export const getEncryptionMopType = (mopType: string): string => {
  if (DIRECT_DEBIT_MOP_TYPES.has(mopType)) {
    return 'DIRECT_DEBIT';
  }
  return mopType;
};

export const buildMopEncryptionPayload = (raw: string, mopType: string): string =>
  JSON.stringify({
    mopReference: raw,
    mopType: getEncryptionMopType(mopType),
    partialMopValidation: false,
  });
